module.exports = function(store) {
  return function(next) {
    return function(action) {
      console.log(action);
      return next(action);
    };
  };
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2FwcC9zcmMvc3RhdGUvTG9nZ2VyTWlkZGxld2FyZS5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvYXBwL3NyYy9zdGF0ZS9Mb2dnZXJNaWRkbGV3YXJlLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQUMsT0FBUCxHQUFpQixTQUFDLEtBQUQ7U0FBVyxTQUFDLElBQUQ7V0FBVSxTQUFDLE1BQUQ7TUFDckMsT0FBTyxDQUFDLEdBQVIsQ0FBWSxNQUFaO2FBQ0EsSUFBQSxDQUFLLE1BQUw7SUFGcUM7RUFBVjtBQUFYIn0=
